import PropTypes from "prop-types";
import React from "react";

import DeleteRouteForm from "v2/components/responsive/DeleteRouteForm";

const DeleteRoutePage = (props, context) => {
  const {location: {query}, params: {date, routeId}, router} = context;
  return (
    <DeleteRouteForm
      onCancel={(evt) => {
        evt.preventDefault();
        router.push({
          pathname: `/${date}/${routeId}`,
          query,
        });
      }} />
  );
};

DeleteRoutePage.contextTypes = {
  location: PropTypes.object,
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
    routeId: PropTypes.string.isRequired,
  }),
  router: PropTypes.object,
};

export default DeleteRoutePage;



/** WEBPACK FOOTER **
 ** ./src/app/v2/pages/DeleteRoutePage.js
 **/